import { getActionFilterQuery } from 'modules/automation-rules/actions/utils/get-action-filter-query'
import { AUTOMATION_RULES_API } from 'modules/automation-rules/api/automation-rules-api'
import { getTriggerFilterQuery } from 'modules/automation-rules/triggers/utils/get-trigger-filter-query'
import { AutomationRuleFilterInterface } from 'modules/automation-rules/types/automation-rule-filter-interface'
import { AutomationRuleApiInterface } from 'modules/automation-rules/types/automation-rule-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { SwrPaginationInterface } from 'shared/types/pagination-interface'
import { baseFetcher } from 'shared/utils/http-client'
import { automationRuleDependencies } from '../constants/automation-rule-dependencies'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'

interface UseAutomationRulesProps extends SwrPaginationInterface {
  filter: AutomationRuleFilterInterface
}

export function useAutomationRules({ limit, pagination, filter }: UseAutomationRulesProps) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, AutomationRuleApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const filterApi = `${
    filter.status !== undefined ? `&filter[active]=${filter.status}` : ''
  }${getTriggerFilterQuery(filter)}${getActionFilterQuery(filter)}`

  const { data: automationRules } = useControlledSwr(() => {
    if (user && pagination.startFromId === undefined && limit) {
      return [
        `${AUTOMATION_RULES_API}/list?pagination[limit]=${limit}${filterApi}`,
        ...automationRuleDependencies,
        RequestModuleEnum.AutomationRule,
      ]
    } else if (user && pagination.startFromId && limit) {
      return [
        `${AUTOMATION_RULES_API}/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`,
        ...automationRuleDependencies,
        RequestModuleEnum.AutomationRule,
      ]
    }
    return null
  }, fetcher)

  const { data: counter } = useControlledSwr(() => {
    if (user) {
      return [
        `${AUTOMATION_RULES_API}/count?pagination[limit]${filterApi}`,
        ...automationRuleDependencies,
        RequestModuleEnum.AutomationRule,
      ]
    }
    return null
  }, baseFetcher)

  return { automationRules, counter }
}
